import clientAuth from "../clientAuth";
export default {
	index: () => clientAuth.get("cancellation/index"),
	store: (userData) => clientAuth.post('cancellation/store', { json: userData }),
	show:(id)=>clientAuth.get('cancellation/show/'+id),
	update:(id,userData)=>clientAuth.post(`cancellation/update/${id}`,{json:userData}),
	destroy:(id)=>clientAuth.delete(`cancellation/destroy/${id}`),

	can_index: () => clientAuth.get("cancellationpolicyItem/index"),
	can_store: (userData) => clientAuth.post('cancellationpolicyItem/store', { json: userData }),
	can_show:(id)=>clientAuth.get('cancellationpolicyItem/show/'+id),
	can_update:(id,userData)=>clientAuth.post(`cancellationpolicyItem/update/${id}`,{json:userData}),
	can_destroy:(id)=>clientAuth.delete(`cancellationpolicyItem/destroy/${id}`),

};